// extracted by mini-css-extract-plugin
export default {"container":"container__GwULG","tabs":"tabs__uMcHC","tab":"tab__wtLkK","active":"active__y-sLy","content":"content__S82E0"};